"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

require("core-js/modules/es6.function.name");

var _axisLabelFormatterOptions = _interopRequireDefault(require("../label-formatters/axis-label-formatter-options"));

var _coerce = _interopRequireDefault(require("@meltwater/coerce"));

var _fillSeriesColor = _interopRequireDefault(require("../fill-series-color"));

var _tooltipFormatters = require("../tooltip-formatters");

var _axisLabelFormatters = require("../label-formatters/axis-label-formatters");

var _highcharts = _interopRequireDefault(require("highcharts"));

var _legendClickHandlers = require("../legend-click-handlers");

var _logger = _interopRequireDefault(require("../logger"));

var _mwChartStackedPercentageColumnOptions = _interopRequireDefault(require("./mw-chart-stacked-percentage-column-options"));

var _mwChartStackedPercentageColumnTooltipOptions = _interopRequireDefault(require("./mw-chart-stacked-percentage-column-tooltip-options"));

var _mwChartStackedPercentageColumnLabelFormatterOptions = _interopRequireDefault(require("./mw-chart-stacked-percentage-column-label-formatter-options"));

var _chartingBackend = require("../charting-backend");

var _nSeriesPointClickOptions = _interopRequireDefault(require("../n-series-point-click-options"));

var _seriesData = _interopRequireDefault(require("../series-data"));

var _styles = require("../styles");

var MAX_SERIES_COUNT = 5;
var PERCENT_STACKING_MODE = 'percent';

function createSeriesOptions(chartData, hiddenSeriesIndices) {
  return chartData.map(function (series, index) {
    var isSeriesVisible = !hiddenSeriesIndices.some(function (seriesIndex) {
      return seriesIndex === index;
    });
    return {
      data: series.data,
      name: series.name,
      visible: isSeriesVisible
    };
  });
}

var MwChartStackedPercentageColumn =
/*#__PURE__*/
function () {
  /**
   * Create a new Stacked Percentage Column Chart
   * @param {string|HTMLElement} renderTarget - The id of, or the HTMLElement for, the element to render into. Note: this element will be emptied!
   */
  function MwChartStackedPercentageColumn(renderTarget) {
    (0, _classCallCheck2.default)(this, MwChartStackedPercentageColumn);

    if (!renderTarget) {
      throw new Error('renderTarget is required');
    }

    this.__chart = null;
    this.__renderTarget = renderTarget;
  }
  /**
   * Set the chart data to be rendered
   * @param {SeriesData} chartData - The data to be rendered to the chart
   * @returns {undefined}
   */


  (0, _createClass2.default)(MwChartStackedPercentageColumn, [{
    key: "setChartData",
    value: function setChartData(chartData) {
      if (!Array.isArray(chartData)) {
        throw new TypeError("chartData must be an Array! Provided value: ".concat(JSON.stringify(chartData)));
      }

      if (chartData.length > MAX_SERIES_COUNT) {
        throw new Error("Array length of chartData must be less or equal than ".concat(MAX_SERIES_COUNT, ". Provided array length: ").concat(chartData.length));
      }

      this.__chartData = chartData.map(function (data) {
        return (0, _coerce.default)(data, _seriesData.default, "chartData should be shaped like a SeriesData. Provided value: ".concat(JSON.stringify(chartData)));
      });
    }
    /**
     * Set the visualization options for the chart
     * @param {MwChartStackedPercentageColumnOptions} chartOptions - The visualization options for the chart
     * @returns {undefined}
     */

  }, {
    key: "setChartOptions",
    value: function setChartOptions(chartOptions) {
      this.__chartOptions = (0, _coerce.default)(chartOptions, _mwChartStackedPercentageColumnOptions.default, "chartOptions must be a valid MwChartStackedColumnOptions object. Provided value: ".concat(JSON.stringify(chartOptions)));
    }
    /**
     * Render the chart to the renderTarget passed in the constructor
     * @returns {undefined}
     */

  }, {
    key: "render",
    value: function render() {
      var _this = this;

      try {
        this.error = false;
        var highchartData = (0, _chartingBackend.nSeriesChartDataToHighchartsData)(this.__chartData);
        var safeHighchartOptions = this.__chartOptions;
        var seriesColors = safeHighchartOptions.seriesColors;

        if (seriesColors !== _styles.DEFAULT_SERIES_CHART_COLORS && seriesColors.length < highchartData.series.length) {
          seriesColors = (0, _fillSeriesColor.default)(seriesColors, highchartData.series.length);
        }

        var seriesOptions = createSeriesOptions(highchartData.series, safeHighchartOptions.hiddenSeriesIndices);

        var safeDataLabelFormatter = function safeDataLabelFormatter() {
          var options = new _mwChartStackedPercentageColumnLabelFormatterOptions.default({
            /* eslint-disable no-invalid-this */
            key: this.key,
            percentage: this.percentage,
            seriesName: this.series.name,
            value: this.y
            /* eslint-enable no-invalid-this */

          });
          return safeHighchartOptions.dataLabelFormatter(options);
        };

        var LEGEND_CURSOR_STYLE = _styles.CURSOR_DEFAULT;

        if (safeHighchartOptions.onLegendClick) {
          LEGEND_CURSOR_STYLE = _styles.CURSOR_POINTER;
        }

        var onLegendClickCallback = (0, _legendClickHandlers.legendClickResolver)({
          chart: this,
          chartData: this.__chartData,
          chartOptions: this.__chartOptions,
          onLegendClick: safeHighchartOptions.onLegendClick
        });

        var safeOnPointClick = function safeOnPointClick(clickEvent) {
          var options = new _nSeriesPointClickOptions.default(clickEvent);
          return safeHighchartOptions.onPointClick(options);
        };

        var tooltipFormatter = safeHighchartOptions.tooltipFormatter;

        if (typeof safeHighchartOptions.tooltipFormatter === 'string') {
          var tooltipFormatterFactory = (0, _tooltipFormatters.getFactory)(tooltipFormatter);
          tooltipFormatter = tooltipFormatterFactory({
            options: this.__chartOptions,
            series: this.__chartData
          });
        }

        var getCurrentHiddenSeriesIndices = function getCurrentHiddenSeriesIndices() {
          return _this.__chartOptions.hiddenSeriesIndices;
        };

        var safeTooltipFormatter = function safeTooltipFormatter() {
          /* eslint-disable no-invalid-this */
          var options = new _mwChartStackedPercentageColumnTooltipOptions.default({
            hiddenSeriesIndices: getCurrentHiddenSeriesIndices(),
            point: this.point,
            series: this.series
          });
          /* eslint-enable no-invalid-this */

          return tooltipFormatter(options);
        };

        var resolvedYAxisLabelFormatter = safeHighchartOptions.yAxisLabelFormatter;

        if (typeof safeHighchartOptions.yAxisLabelFormatter === 'string') {
          resolvedYAxisLabelFormatter = (0, _axisLabelFormatters.getFormatter)(safeHighchartOptions.yAxisLabelFormatter);
        }

        var safeYAxisLabelFormatter = function safeYAxisLabelFormatter() {
          var options = new _axisLabelFormatterOptions.default({
            /* eslint-disable no-invalid-this */
            isFirst: this.isFirst,
            isLast: this.isLast,
            value: this.value
            /* eslint-enable no-invalid-this */

          });
          return resolvedYAxisLabelFormatter(options);
        };

        this.__chart = _highcharts.default.chart(this.__renderTarget, {
          title: {
            text: ''
          },
          chart: {
            renderTo: this.__renderTarget,
            reflow: false,
            type: 'column',
            style: {
              fontFamily: _styles.FONT_FAMILY,
              color: _styles.AXIS_LABEL_FONT_COLOR
            }
          },
          colors: seriesColors,
          credits: {
            enabled: false
          },
          exporting: {
            enabled: false
          },
          legend: {
            enabled: !safeHighchartOptions.hideLegend,
            itemStyle: {
              color: _styles.LEGEND_LABEL_FONT_COLOR,
              cursor: LEGEND_CURSOR_STYLE,
              fontSize: _styles.LEGEND_LABEL_FONT_SIZE,
              fontWeight: _styles.LEGEND_LABEL_FONT_WEIGHT
            },
            itemHoverStyle: {
              color: _styles.LEGEND_LABEL_FONT_COLOR
            }
          },
          plotOptions: {
            column: {
              animation: safeHighchartOptions.animate,
              stacking: PERCENT_STACKING_MODE,
              dataLabels: {
                enabled: safeHighchartOptions.areDataLabelsVisible,
                formatter: safeDataLabelFormatter
              },
              events: {
                click: safeOnPointClick,
                legendItemClick: onLegendClickCallback
              }
            }
          },
          series: seriesOptions,
          tooltip: {
            formatter: safeTooltipFormatter,
            useHTML: true
          },
          xAxis: {
            categories: highchartData.categories,
            labels: {
              style: {
                color: _styles.AXIS_LABEL_FONT_COLOR
              }
            },
            lineWidth: _styles.X_AXIS_LINE_WIDTH,
            lineColor: _styles.LINE_AND_TICK_COLOR,
            tickColor: _styles.LINE_AND_TICK_COLOR
          },
          yAxis: {
            gridLineColor: _styles.LINE_AND_TICK_COLOR,
            labels: {
              formatter: safeYAxisLabelFormatter,
              style: {
                color: _styles.AXIS_LABEL_FONT_COLOR,
                fontWeight: _styles.AXIS_LABEL_FONT_WEIGHT
              }
            },
            title: {
              text: safeHighchartOptions.yAxisTitle,
              style: {
                color: _styles.AXIS_LABEL_FONT_COLOR,
                fontWeight: _styles.AXIS_LABEL_FONT_WEIGHT
              }
            }
          }
        });
      } catch (error) {
        this.error = true;

        _logger.default.error('Chart failed to render.', error);

        this.__chartOptions.onError(error);
      }
    }
    /**
     *  Update which series are currently hidden
     *
     * @param {number[]} hiddenSeriesIndices - The indices of the series to be hidden
     *
     * @returns {undefined}
     */

  }, {
    key: "updateHiddenSeriesIndices",
    value: function updateHiddenSeriesIndices(hiddenSeriesIndices) {
      (0, _chartingBackend.updateHiddenSeriesIndices)({
        chart: this,
        chartData: this.__chartData,
        chartInstance: this.__chart,
        chartOptions: this.__chartOptions,
        hiddenSeriesIndices: hiddenSeriesIndices
      });
    }
  }]);
  return MwChartStackedPercentageColumn;
}();

exports.default = MwChartStackedPercentageColumn;